import { render } from "./UserManuals.vue?vue&type=template&id=2e71c388&scoped=true"
import script from "./UserManuals.vue?vue&type=script&lang=js"
export * from "./UserManuals.vue?vue&type=script&lang=js"

import "./UserManuals.vue?vue&type=style&index=0&id=2e71c388&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e71c388"]])

export default __exports__